import React from 'react';
import { motion } from 'framer-motion';
const quotes = [{
  text: 'Ella se reviste de fuerza y dignidad; y sonríe sin temor al futuro.',
  reference: 'Salmo 31:25'
}, {
  text: 'Dios es nuestro amparo y fortaleza, nuestro pronto auxilio en las tribulaciones.',
  reference: 'Salmo 46:1'
}, {
  text: 'Deléitate asimismo en el Señor, y Él te concederá las peticiones de tu corazón.',
  reference: 'Salmo 37:4'
}];
export function ScriptureQuotes() {
  return <section className="py-20 bg-ivory relative" data-id="element-123">
      <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-124">
        <div className="mb-12" data-id="element-125">
          <h2 className="text-2xl md:text-3xl font-serif text-gold mb-2" data-id="element-126">
            Palabras que me sostienen
          </h2>
          <div className="w-24 h-[1px] bg-gold/30 mx-auto" data-id="element-127" />
        </div>

        <div className="space-y-12" data-id="element-128">
          {quotes.map((quote, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2,
          duration: 0.8
        }} className="flex flex-col items-center" data-id="element-129">
              <p className="text-xl md:text-2xl font-serif italic text-softBlack mb-3 leading-relaxed" data-id="element-130">
                "{quote.text}"
              </p>
              <span className="text-sm text-warmGray uppercase tracking-widest text-xs" data-id="element-131">
                {quote.reference}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}